/**
 * Hero Guests Horizontal Scroll with Active Indicators
 * Affiche les indicateurs de progression du scroll
 */

class HeroGuestsScroll {
  constructor() {
    this.container = document.querySelector('.hero-guests-mobile .overflow-x-auto');
    this.indicators = document.querySelectorAll('.hero-guests-mobile .w-1\\.5');

    if (!this.container || this.indicators.length === 0) {
      return;
    }

    this.init();
  }

  init() {
    // Mettre à jour les indicateurs lors du scroll
    this.container.addEventListener('scroll', () => {
      this.updateIndicators();
    }, { passive: true });

    // Initial update
    this.updateIndicators();
  }

  updateIndicators() {
    const scrollLeft = this.container.scrollLeft;
    const scrollWidth = this.container.scrollWidth - this.container.clientWidth;
    const scrollPercentage = scrollWidth > 0 ? scrollLeft / scrollWidth : 0;

    const activeIndex = Math.round(scrollPercentage * (this.indicators.length - 1));

    this.indicators.forEach((indicator, index) => {
      if (index === activeIndex) {
        indicator.classList.remove('bg-white/30');
        indicator.classList.add('bg-primary');
      } else {
        indicator.classList.remove('bg-primary');
        indicator.classList.add('bg-white/30');
      }
    });
  }
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeroGuestsScroll();
  });
} else {
  new HeroGuestsScroll();
}
